import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';
import { Subscription } from 'rxjs';
import { User } from '../../core/models/user';
import { Router } from '@angular/router';
import { AdminControlService } from '../../core/services/admin-control.service';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
})
export class AdminLayoutComponent implements OnInit, OnDestroy {
  isCollapsed = false;
  user = { name: '', role: '', url: '' };
  private userSub: Subscription = new Subscription();
  isAuthenticated = false;
  sljiDatabaseLink: string = 'http://203.143.7.146:89/PdfSearch/login2_process.php';

  constructor(
    private authService: AuthService,
    private router: Router,
    private adminControlService: AdminControlService,
  ) {}

  ngOnInit(): void {
    this.userSub = this.authService.user.subscribe((user: User | null) => {
      this.isAuthenticated = !!user;
      this.user.name = user?.name || '';
      this.user.role = 'member';
      this.user.url =
        (user?.profilePicture as { url: string } | undefined)?.url || '';
    });
    this.loadDatabaseLink();
  }

  loadDatabaseLink(): void {
    this.adminControlService.getControls().then((controls) => {
      if (controls?.sljiDatabaseLink) {
        this.sljiDatabaseLink = controls.sljiDatabaseLink;
      }
    }).catch(() => {
      // If API call fails, use default link
      console.warn('Failed to load database link from CMS, using default');
    });
  }

  layoutChange(event: any):void{
  }

  logout(): void {
    this.authService.logout();
  }

  ngOnDestroy() {
    this.userSub.unsubscribe();
  }

  routeToProfile() {
    this.router.navigate(['/admin/my-profile']);
  }

  navigation(route: string): void {
    this.router.navigate([route]);
  }

  openSLJIDatabase(): void {
    window.open(this.sljiDatabaseLink, '_blank');
  }
}
